/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React from 'react';
import { Fade } from 'react-awesome-reveal';
import Button from 'elements/Button';

export default function BlogList({ data }) {
  return (
    <section className="container mx-auto pt-24 pb-20">
      <Fade bottom>
        <h1 className="text-5xl text-theme-blue text-center font-bold mb-4">
          Artikel Terbaru Kami
        </h1>
        <p className="text-gray-600 text-center max-w-2xl mx-auto mb-12">
          Tips, panduan, dan informasi terkini seputar teknologi CNC, perawatan mesin, dan industri manufaktur dari para ahli teknisi kami.
        </p>
      </Fade>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 px-4">
        {data.map((item, index) => (
          <Fade bottom delay={100 * Math.min(index, 6)} key={item.id}>
            <article className="border border-gray-200 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300 flex flex-col h-full bg-white">
              <div className="h-48 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  loading="lazy"
                  className="w-full h-full object-cover transform hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6 flex flex-col flex-grow">
                <div className="flex justify-between items-center mb-3">
                  <span className="text-xs font-semibold text-theme-purple bg-purple-100 px-2 py-1 rounded">
                    Info CNC
                  </span>
                  <time className="text-gray-500 text-xs" dateTime={item.date}>{item.date}</time>
                </div>
                <h2 className="text-xl font-bold text-theme-blue mb-3 line-clamp-2">
                  {item.title}
                </h2>
                <p className="text-gray-600 text-sm mb-4 flex-grow line-clamp-3">
                  {item.summary}
                </p>
                <div className="mt-auto">
                  <Button
                    className="text-theme-purple hover:text-dark-theme-purple font-medium text-sm flex items-center gap-2"
                    type="link"
                    href={`/blog/${item.id}`}
                  >
                    Baca Selengkapnya
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </Button>
                </div>
              </div>
            </article>
          </Fade>
        ))}
      </div>
    </section>
  );
}
